import { render, staticRenderFns } from "./add-tv-admin-form.vue?vue&type=template&id=e1408d5a&"
import script from "./add-tv-admin-form.vue?vue&type=script&lang=ts&"
export * from "./add-tv-admin-form.vue?vue&type=script&lang=ts&"
import style0 from "./add-tv-admin-form.vue?vue&type=style&index=0&id=e1408d5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports